import React from 'react';
import Button from '../elements-buttons/Button';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const CreditIncentiveBanner = ({ creditIncentiveAction }) => {
  return (
    <div className="CreditIncentiveBanner ps-credit-card flex column-xs-reverse margin-xl-top">
      <div className="col-xs-12 col-sm-8 no-gutter">
        <div className="margin-xl-bottom">
          <h5>
            <FormattedMessage
              id='inbox_id_cancel_booking.credit_incentive_banner.receive_bonus'
              defaultMessage='Receive a {percent} bonus'
              values={{
                percent: <FormattedNumber value={0.2} style='percent' />
              }}
            />
          </h5>
          <p className="text-gray-dark">
            <FormattedMessage
              id='inbox_id_cancel_booking.credit_incentive_banner.cancel_credit'
              defaultMessage='If you cancel for Peerspace Credits, you’ll receive a {percent} bonus on top of your refund amount.'
              values={{
                percent: <FormattedNumber value={0.2} style='percent' />
              }}
            />
          </p>
        </div>

        <Button
          className="credit-cta margin-xl-top margin-lg-bottom block-xs-right"
          onClick={creditIncentiveAction}
          type="button"
          category="gray-outline"
          attributes={{
            'data-testing-id': 'cancel-for-credit-btn'
          }}
        >
          <FormattedMessage
            id='inbox_id_cancel_booking.credit_incentive_banner.cancel_for'
            defaultMessage='Cancel for credit + {percent}'
            values={{
              percent: <FormattedNumber value={0.2} style='percent' />
            }}
          />
        </Button>
      </div>

      <div className="flex middle center">
        <img
          className="hidden-xs"
          src="https://assets.peerspace.com/ps-credit-incentive-banner.png?v=rb"
          alt="ps-credit"
        />
        <img
          className="visible-xs"
          src="https://assets.peerspace.com/ps-credit-incentive-banner-mobile.png?v=rb"
          alt="ps-credit"
        />
      </div>
    </div>
  );
};

export default CreditIncentiveBanner;
